/**
 * Data export options abstraction.
 */
export abstract class DataExportOptions {
	fileUuid!: string;
	fileName?: string;
	fileExtension?: string;
	fileMimeType?: string;
}
